import { useLocation } from "react-router-dom";
import { Item, Option, Stage, NameDependency } from "../types/productTypes";
import { translations } from "../translations";

type TranslatableItem = Item | Option | Stage;

export function useTranslation() {
   const location = useLocation();

   // Are we on an /is/... path?
   const isIcelandic = location.pathname.startsWith("/is");

   // Pick the right translation object
   const translation = translations[isIcelandic ? "is" : "en"];

   // Turn any string path into a localized one:
   const localizePath = (to: string) => {
      const prefix = isIcelandic ? "/is" : "";
      // make sure there's exactly one slash between prefix and to
      const normalized = to.startsWith("/") ? to : `/${to}`;
      return `${prefix}${normalized}`;
   };

   const translateNameChange = (nameDependency: NameDependency) => {
      if (isIcelandic) {
         return nameDependency.islandicNameChange;
      }
      return nameDependency.nameChange;
   };

   // As before: a translation function for items
   const translate = (item: TranslatableItem): string => {
      let defaultName = "";
      try {
         defaultName =
            "stageName" in item
               ? item.stageName
               : // @ts-ignore
                 item.name;
      } catch (error) {
         console.log("error", error);
         return defaultName;
      }

      if (
         isIcelandic &&
         // @ts-ignore
         item.islandicName &&
         // @ts-ignore
         item.islandicName.trim().length > 0
      ) {
         // @ts-ignore
         return item.islandicName;
      }

      return defaultName;
   };

   return {
      translation,
      translate,
      isIcelandic,
      currentLanguage: isIcelandic ? "is" : "en",
      localizePath,
      translateNameChange,
   };
}
